import useSwr from 'swr'
import axios from 'axios'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'
import { Inscription } from '@/utils/types/inscription'

const fetcher = async ([_url, address]: any) => {
	if (!address) {
		return []
	}

	try {
		const { data } = await axios.get(`${API_URL}/wallet/${address}/inscriptions`)

		// @ts-ignore
		return data
	} catch {
		return []
	}
}

export default function useWalletInscriptions(address?: string): {
	data: Inscription[]
	isLoading: boolean
} {
	const a = address || Wallet.getTaprootAddress()
	return useSwr([`/wallet-${a}-inscriptions`, a], fetcher)
}
